import type {
	LogIpSortKey,
	LogPathSortKey,
	RequestMiss,
	RequestMissIp,
	RequestMissPath,
	SortDir,
} from "shared";
import { api } from "./client";

export interface ListLogsResult {
	misses: RequestMissPath[];
	nextCursor: string | null;
}

export async function listLogs(opts?: {
	q?: string;
	cursor?: string;
	sort?: LogPathSortKey;
	order?: SortDir;
}): Promise<ListLogsResult> {
	const params = new URLSearchParams();
	if (opts?.q) params.set("q", opts.q);
	if (opts?.cursor) params.set("cursor", opts.cursor);
	if (opts?.sort) params.set("sort", opts.sort);
	if (opts?.order) params.set("order", opts.order);
	const qs = params.toString();
	return api.get(`/logs${qs ? `?${qs}` : ""}`);
}

export async function getLogDetail(
	path: string,
): Promise<{ misses: RequestMiss[] }> {
	return api.get(`/logs/detail?path=${encodeURIComponent(path)}`);
}

export interface ListLogIpsResult {
	ips: RequestMissIp[];
	nextCursor: string | null;
}

export async function listLogIps(opts?: {
	q?: string;
	cursor?: string;
	sort?: LogIpSortKey;
	order?: SortDir;
}): Promise<ListLogIpsResult> {
	const params = new URLSearchParams();
	if (opts?.q) params.set("q", opts.q);
	if (opts?.cursor) params.set("cursor", opts.cursor);
	if (opts?.sort) params.set("sort", opts.sort);
	if (opts?.order) params.set("order", opts.order);
	const qs = params.toString();
	return api.get(`/logs/ips${qs ? `?${qs}` : ""}`);
}

export async function getLogsByIp(
	ip: string,
): Promise<{ misses: RequestMiss[] }> {
	return api.get(`/logs/by-ip?ip=${encodeURIComponent(ip)}`);
}
